// plugins/structured-clone.js
import structuredClone from '@ungap/structured-clone'

export default () => {
  if (
    typeof window !== 'undefined' &&
    typeof window.structuredClone === 'undefined'
  ) {
    window.structuredClone = structuredClone
  }

  // SSR側でも使えるように globalThis にも登録
  if (typeof globalThis.structuredClone === 'undefined') {
    globalThis.structuredClone = structuredClone
  }
}
